import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import styles from "./IndividuFormulari.module.css";
import ErrorBoundaryWrapper from "../commons/ErrorBoundaryWrapper";
import { Select, Input, DatePicker, Switch, List, InputNumber } from "antd";
import { modificarValorBooleanPerTextSiNo } from "../commons/TaulaOrdenacioCerca";
import PopOverError from "../commons/PopOverError";
import {
  individuIntroduccioModificarCamp,
  setTitolApartat,
  obtenirObservadorsLlistat,
  inicialitzarIndividu,
  obtenirDadesCreacioIndividu,
  obtenirDadesVisualitzacio
} from "../../actions";
import {
  getDadesEditadesIndividu,
  getDadesOriginalsIndividu,
  getMostrarErrorsIndividu,
  getObservadorsUsuari,
  obtenirIndrets,
  obtenirCollectius,
  obtenirGeneres,
  obtenirRegnes,
  obtenirVarietats,
  getTotesEspecies,
  getTotesClasses,
  obtenirSubEspecies,
  getTotesFenofases,
  getNumObservacions
} from "../../reducers";

import {
  TEXT_QUAN_NO_HI_HA_DADA,
  TITOL_CREAR_INDIVIDU,
  TITOL_EDITAR_INDIVIDU,
  TITOL_DADES_INDIVIDU,
  VALOR_MAX_DESCRIPCIO_INDIVIDU,
  ORIENTACIO_NOM_VALOR_DEFECTE,
  ORIGEN_NOM_VALOR_DEFECTE,
  TRACTAMENT_NOM_VALOR_DEFECTE,
  IRRIGACIO_NOM_VALOR_DEFECTE,
  ID_CLASSE_VEGETAL,
  VALOR_MIN_ALÇADA_INDIVIDU,
  VALOR_MAX_ALÇADA_INDIVIDU,
  NUM_DECIMALS_COORDENADES,
  MAX_BOUNDS_COORDENADES,
  ORIENTACIO_NOM_VALOR_SOLANA,
  ORIENTACIO_NOM_VALOR_OBAGA
} from "../../constantsFormularis";

import VariableLlista from "../commons/variableLlista";
import {
  MASCARA_DDMMYYYY,
  MASCARA_YYYYMMDD,
  convertirTextAMomentUTC
} from "../../utils/dates";
import { obtenirErrorsDadesIndividu } from "../../utils/formularis";
import { NotificacioError } from "../Notification";

const LATITUD_MIN = MAX_BOUNDS_COORDENADES[1][0];
const LATITUD_MAX = MAX_BOUNDS_COORDENADES[0][0];
const LONGITUD_MIN = MAX_BOUNDS_COORDENADES[0][1];
const LONGITUD_MAX = MAX_BOUNDS_COORDENADES[1][1];
const separador = "#&";

const nomCampObservador = "nomObservador";
const nomCampIdObservador = "idObservador";
const nomCampNomIndret = "nomIndret";
const nomCampIdIndret = "idIndret";
const nomCampIndret = "nomIndret";
const nomCampDataAlta = "indretIndividuDataAlta";
const nomCampDataBaixa = "dataBaixa";
const nomCampDescripcio = "descripcio";
const nomCampNomCientific = "nomCientific";
const nomCampLatitud = "latitud";
const nomCampLongitud = "longitud";
const nomCampAltitud = "altitud";
const nomCampRegne = "nomRegne";
const nomCampClasse = "nomClasse";
const idCampClasse = "idClasse";
const nomCampCollectiu = "nomCollectiu";
const nomCampGenere = "nomGenere";
const nomCampEspecie = "nomEspecie";
const nomCampIdEspecie = "idEspecie";
const nomCampSubEspecie = "nomSubespecie";
const nomCampIdSubEspecie = "idSubespecie";
const nomCampVarietat = "nomVarietat";
const nomCampIdVarietat = "idVarietat";
const nomCampFenofases = "fenofases";
const nomCampfenofases = "fenofases";
const nomCampCanvis = "canvis";
const nomCampOrientacio = "solana";
const nomCampOrigen = "plantada";
const nomCampIrrigacio = "reg";
const nomCampTractament = "fertilitzat";
const nomCampGenotip = "genotip";

const renderitzarError = errorCamp => {
  if (errorCamp) {
    return <PopOverError contingut={errorCamp} classNameIcona="icona-error" />;
  }
  // Es necessari retornar un div buit i no null perquè cssGrid ho interpreti com a contingut
  return <div />;
};

const renderitzarCampTipusTextCalculat = valor => {
  return valor ? valor.toString() : TEXT_QUAN_NO_HI_HA_DADA;
};

const renderitzarCampTipusNumber = (
  nomCamp,
  esEditable,
  valor,
  indretIntroduccioModificarCamp,
  valorMin,
  valorMax,
  NumMaxDecimals
) => {
  if (!esEditable) {
    // si hi ha valor, sempre es passa a string perquè això ens assegurem que si és una variable booleana aparegui
    return valor ? valor.toString() : TEXT_QUAN_NO_HI_HA_DADA;
  }
  return (
    <InputNumber
      aria-labelledby={"id-" + nomCamp}
      min={valorMin}
      max={valorMax}
      step={NumMaxDecimals ? 1 / Math.pow(10, NumMaxDecimals) : 1}
      onChange={valor => indretIntroduccioModificarCamp(nomCamp, valor)}
      value={valor}
      precision={NumMaxDecimals ? NumMaxDecimals : 0}
    />
  );
};

const renderitzarCampTipusText = (
  nomCamp,
  esEditable,
  valor,
  individuIntroduccioModificarCamp
) => {
  if (!esEditable) {
    // si hi ha valor, sempre es passa a string perquè això­ ens assegurem que si és una variable booleana aparegui
    if (nomCamp === nomCampOrientacio) {
      return valor === "Sí­" || valor === true
        ? ORIENTACIO_NOM_VALOR_SOLANA
        : valor === "No" || valor === false
          ? ORIENTACIO_NOM_VALOR_OBAGA
          : TEXT_QUAN_NO_HI_HA_DADA;
    }
    return valor ? valor.toString() : TEXT_QUAN_NO_HI_HA_DADA;
  }

  return (
    <Input
      defaultValue={valor}
      aria-labelledby={"id-" + nomCamp}
      onBlur={event => {
        const valor = event.target.value;
        individuIntroduccioModificarCamp(nomCamp, valor ? valor : null);
      }}
    />
  );
};

const renderitzarCampTipusLlista = (
  nomCamp,
  esEditable,
  valor,
  valorsPossibles,
  individuIntroduccioModificarCamp
) => {
  if (!esEditable) {
    const valorCercat = valorsPossibles.find(
      valorPossible => valorPossible.nom === valor
    );

    return valorCercat && valorCercat.valor ? valorCercat.valor : valor;
  }

  const estilsSelector = {
    selector: styles.individuLlistatSelector
  };

  const variable = { id: nomCamp, nom: null, valor, valorsPossibles };

  return (
    <VariableLlista
      estils={estilsSelector}
      variable={variable}
      onChangeValorVariable={valor => {
        const valortext = valorsPossibles.filter(
          element => element.id === valor
        );
        individuIntroduccioModificarCamp(nomCamp, valortext[0].valor);
      }}
      allowClear={false}
    />
  );
};

const renderitzarCampTipusData = (
  nomCamp,
  esEditable,
  valor,
  individuIntroduccioModificarCamp
) => {
  const dataSeleccionadaText = valor;
  const dataSeleccionada = dataSeleccionadaText
    ? convertirTextAMomentUTC(dataSeleccionadaText, MASCARA_YYYYMMDD)
    : null;

  if (!esEditable) {
    return dataSeleccionada
      ? dataSeleccionada.format(MASCARA_DDMMYYYY)
      : TEXT_QUAN_NO_HI_HA_DADA;
  }

  return (
    <DatePicker
      className={styles.individuFormulariData}
      aria-labelledby={"id-" + nomCamp}
      defaultValue={dataSeleccionada}
      onChange={date => {
        const dataText = date ? date.format(MASCARA_YYYYMMDD) : null;
        individuIntroduccioModificarCamp(nomCamp, dataText);
      }}
      format={MASCARA_DDMMYYYY}
    />
  );
};

const renderitzarCampTipusTextArea = (
  nomCamp,
  esEditable,
  valor,
  individuIntroduccioModificarCamp
) => {
  const { TextArea } = Input;

  if (!esEditable) {
    // si hi ha valor, sempre es passa a string perquè això­ ens assegurem que si és una variable booleana aparegui
    return valor ? valor.toString() : TEXT_QUAN_NO_HI_HA_DADA;
  }

  return (
    <TextArea
      aria-labelledby={"id-" + nomCamp}
      className={styles.individuDescripcioCamp}
      autoSize={{ minRows: 3, maxRows: 5 }}
      onChange={event => {
        const valor = event.target.value;
        individuIntroduccioModificarCamp(nomCamp, valor ? valor : null);
      }}
      maxLength={VALOR_MAX_DESCRIPCIO_INDIVIDU}
      value={valor}
      disabled={!esEditable}
    />
  );
};

class IndividuFormulari extends Component {
  state = {
    disableComponents: false
  };

  componentDidMount() {
    const { esEditable, dadesOriginals } = this.props;

    if (esEditable) {
      this.obtenirObservadors();
      this.obtenirDadesAuxiliars();
      this.obtenirEspeciesFenofases();
    }

    const esNouIndividu =
      dadesOriginals[nomCampIdObservador] === null ? true : false;

    if (esNouIndividu) {
      this.props.inicialitzarIndividu();
    }

    this.props.setTitolApartat(
      esNouIndividu
        ? TITOL_CREAR_INDIVIDU
        : esEditable
          ? TITOL_EDITAR_INDIVIDU
          : !esEditable ? TITOL_DADES_INDIVIDU : ""
    );
  }

  obtenirObservadors = () => {
    this.props
      .obtenirObservadorsLlistat()
      .then(dades => {
        if (dades.error && dades.error.message) {
          const msg = dades.error || dades.error.message;
          const title = dades.titol || "Aví­s obtenint llistat observadors";
          return NotificacioError(title, msg);
        }
      })
      .catch(error => {
        if (error.message && error.titol) {
          return NotificacioError(error.titol, error.message);
        }
      });
  };

  obtenirDadesAuxiliars = () => {
    this.props
      .obtenirDadesCreacioIndividu()
      .then(dades => {
        if (dades.error && dades.error.message) {
          const msg = dades.error || dades.error.message;
          const title = dades.titol || "Aví­s obtenit dades Individu";
          return NotificacioError(title, msg);
        }
      })
      .catch(error => {
        if (error.message || error.error) {
          const errorMsg = error.message || error.error;
          const errorTitle = error.titol || "Error obtenit dades Individu";
          return NotificacioError(errorTitle, errorMsg);
        }
      });
  };

  obtenirEspeciesFenofases = () => {
    this.props
      .obtenirDadesVisualitzacio()
      .then(dades => {
        if (dades.error && dades.error.message) {
          const msg = dades.error || dades.error.message;
          const title =
            dades.titol || "Aví­s obtenit Especies/fenofases Individu";
          return NotificacioError(title, msg);
        }
      })
      .catch(error => {
        if (error.message || error.error) {
          const errorMsg = error.message || error.error;
          const errorTitle =
            error.titol || "Error obtenit Especies/fenofases Individu";
          return NotificacioError(errorTitle, errorMsg);
        }
      });
  };

  disableComponent = value => {
    this.setState({ disableComponents: value });
  };

  renderitzarComponentSegonsTipus(
    nomCamp,
    esEditable,
    tipusCamp,
    valorsPossibles,
    valorMin,
    valorMax,
    NumMaxDecimals
  ) {
    const {
      dadesEditades,
      dadesOriginals,
      individuIntroduccioModificarCamp
    } = this.props;

    const valor = esEditable
      ? dadesEditades &&
        (dadesEditades[nomCamp] || dadesEditades[nomCamp] === false)
        ? dadesEditades[nomCamp]
        : null
      : dadesOriginals &&
        (dadesOriginals[nomCamp] || dadesOriginals[nomCamp] === false)
        ? dadesOriginals[nomCamp]
        : null;

    switch (tipusCamp) {
      case "number": {
        return renderitzarCampTipusNumber(
          nomCamp,
          esEditable,
          valor,
          individuIntroduccioModificarCamp,
          valorMin,
          valorMax,
          NumMaxDecimals
        );
      }

      case "calculat": {
        return renderitzarCampTipusTextCalculat(valor);
      }

      case "text": {
        return renderitzarCampTipusText(
          nomCamp,
          esEditable,
          valor,
          individuIntroduccioModificarCamp
        );
      }

      case "boolean": {
        return renderitzarCampTipusText(
          nomCamp,
          esEditable,
          modificarValorBooleanPerTextSiNo(valor),
          individuIntroduccioModificarCamp
        );
      }

      case "llista": {
        return renderitzarCampTipusLlista(
          nomCamp,
          esEditable,
          valor,
          valorsPossibles,
          individuIntroduccioModificarCamp
        );
      }

      case "data": {
        return renderitzarCampTipusData(
          nomCamp,
          esEditable,
          valor,
          individuIntroduccioModificarCamp
        );
      }
      case "textarea": {
        return renderitzarCampTipusTextArea(
          nomCamp,
          esEditable,
          valor,
          individuIntroduccioModificarCamp
        );
      }

      default:
        return null;
    }
  }

  renderitzarComponentCalculat(nomCamp) {
    return this.renderitzarComponentSegonsTipus(nomCamp, true, "calculat");
  }

  renderitzarComponentBoolean(nomCamp, esEditable) {
    return this.renderitzarComponentSegonsTipus(nomCamp, esEditable, "boolean");
  }

  renderitzarComponentText(nomCamp, esEditable) {
    return this.renderitzarComponentSegonsTipus(nomCamp, esEditable, "text");
  }

  renderitzarComponentNumber(
    nomCamp,
    esEditable,
    valorMin,
    valorMax,
    NumMaxDecimals
  ) {
    return this.renderitzarComponentSegonsTipus(
      nomCamp,
      esEditable,
      "number",
      null,
      valorMin,
      valorMax,
      NumMaxDecimals
    );
  }

  renderitzarComponentTextArea(nomCamp, esEditable) {
    return this.renderitzarComponentSegonsTipus(
      nomCamp,
      esEditable,
      "textarea"
    );
  }

  renderitzarComponentLlista(nomCamp, valorsPossibles, esEditable) {
    return this.renderitzarComponentSegonsTipus(
      nomCamp,
      esEditable,
      "llista",
      valorsPossibles
    );
  }

  renderitzarComponentData(nomCamp, esEditable) {
    return this.renderitzarComponentSegonsTipus(nomCamp, esEditable, "data");
  }

  renderitzarCampObservador() {
    const {
      dadesEditades,
      esEditable,
      observadors,
      individuIntroduccioModificarCamp
    } = this.props;
    const { Option } = Select;
    const idObservadorSeleccionat =
      dadesEditades && dadesEditades[nomCampIdObservador] !== null
        ? dadesEditades[nomCampIdObservador]
        : "";

    if (!esEditable) {
      return dadesEditades ? dadesEditades.nomObservador : "";
    }

    if (!observadors || !Array.isArray(observadors)) {
      return "";
    }

    const llistaObservadorSeleccionat = observadors.filter(observador => {
      return observador.id === parseInt(idObservadorSeleccionat);
    });

    const nomObservadorSeleccionat =
      llistaObservadorSeleccionat && llistaObservadorSeleccionat.length > 0
        ? `${llistaObservadorSeleccionat[0].nom
            ? llistaObservadorSeleccionat[0].nom
            : ""} ${llistaObservadorSeleccionat[0].cognom1
            ? llistaObservadorSeleccionat[0].cognom1
            : ""} ${llistaObservadorSeleccionat[0].cognom2
            ? llistaObservadorSeleccionat[0].cognom2
            : ""}`
        : "";

    const valor =
      idObservadorSeleccionat && nomObservadorSeleccionat
        ? `${nomObservadorSeleccionat}${separador}${idObservadorSeleccionat}`
        : "";
    const idCamp = `id-${nomCampIdObservador}`;
    const nomCamp = `id-${nomCampObservador}`;

    let observadorsOrdenats = [...observadors];
    observadorsOrdenats.sort((a, b) => {
      if (a.cognom1 < b.cognom1) {
        return -1;
      }
      if (a.cognom1 > b.cognom1) {
        return 1;
      }
      return 0;
    });

    return (
      <Select
        showSearch
        placeholder="Selecciona un observador..."
        aria-labelledby={nomCamp}
        style={{ width: "100%", maxHeight: 100 }}
        id={idCamp}
        onChange={valorSeleccionat => {
          const idObservador = valorSeleccionat.substr(
            valorSeleccionat.indexOf(separador) + 2
          );
          const nomObservador = valorSeleccionat.substr(
            0,
            valorSeleccionat.indexOf(separador)
          );
          individuIntroduccioModificarCamp(
            nomCampIdObservador,
            parseInt(idObservador)
          );
          individuIntroduccioModificarCamp(
            nomCampObservador,
            String(nomObservador)
          );
          individuIntroduccioModificarCamp(nomCampIdIndret, "");
          individuIntroduccioModificarCamp(nomCampIndret, "");
        }}
        value={valor ? valor : "Selecciona un observador..."}
      >
        {observadorsOrdenats.map(observador => {
          const nomObservador = `${observador.nom
            ? observador.nom
            : ""} ${observador.cognom1
            ? observador.cognom1
            : ""} ${observador.cognom2 ? observador.cognom2 : ""}`;
          return (
            <Option
              key={observador.id}
              value={`${nomObservador}${separador}${observador.id}`}
            >
              {nomObservador}
            </Option>
          );
        })}
      </Select>
    );
  }

  renderitzaFenofasesLectura(fenofases) {
    let data = [];
    fenofases.forEach(function(item) {
      const fenofase = {
        title: item.codiBbchFenofase ? item.codiBbchFenofase + " - " : "",
        description: item.nomFenofase
      };
      data.push(fenofase);
    });

    data.sort(function(a, b) {
      var keyA = a.title,
        keyB = b.title;
      // Compare the 2 dates
      if (keyA < keyB) {
        return -1;
      }
      if (keyA > keyB) {
        return 1;
      }
      return 0;
    });

    return (
      <div className={styles.listFenofases}>
        <List
          bordered
          size="small"
          dataSource={data}
          renderItem={item => (
            <List.Item>{`${item.title}${item.description}`}</List.Item>
          )}
        />
      </div>
    );
  }

  renderitzarCampFenofases() {
    const {
      dadesEditades,
      esEditable,
      fenofases,
      individuIntroduccioModificarCamp
    } = this.props;

    const { Option } = Select;
    const dades = this.renderitzaFenofasesLectura(
      dadesEditades.fenofases ? dadesEditades.fenofases : []
    );

    if (!esEditable) {
      return dades ? dades : "";
    }

    if (!fenofases || !Array.isArray(fenofases)) {
      return "";
    }

    const idFenofaseSeleccionada =
      dadesEditades && dadesEditades[nomCampfenofases] !== null
        ? dadesEditades[nomCampfenofases]
        : "";

    const idEspecieSeleccionada =
      dadesEditades && dadesEditades[nomCampIdEspecie] !== null
        ? dadesEditades[nomCampIdEspecie]
        : "";

    const llistaFenofasesMostrar = idEspecieSeleccionada
      ? fenofases.filter(fenofase => {
          return fenofase.idEspecie === parseInt(idEspecieSeleccionada);
        })
      : [];

    const valor =
      idFenofaseSeleccionada && Array.isArray(idFenofaseSeleccionada)
        ? idFenofaseSeleccionada.map(fenofase => {
            return {
              key: fenofase.key ? fenofase.key : fenofase.idFenofase.toString()
            };
          })
        : [];
    const idCamp = `id-${nomCampfenofases}`;

    return (
      <Select
        mode="multiple"
        labelInValue
        placeholder="Selecciona les fenofases..."
        aria-labelledby={"id-" + idCamp}
        style={{ width: "100%", maxHeight: 100 }}
        id={idCamp}
        disabled={!idEspecieSeleccionada ? true : false}
        onChange={valorSeleccionat => {
          individuIntroduccioModificarCamp(
            nomCampfenofases,
            JSON.parse(JSON.stringify(valorSeleccionat))
          );
        }}
        value={valor}
      >
        {llistaFenofasesMostrar.map(fenofase => {
          const nomFenofase = `${fenofase.nom}`;
          return <Option key={fenofase.id}>{nomFenofase}</Option>;
        })}
      </Select>
    );
  }

  renderitzarCampIndret() {
    const {
      dadesEditades,
      esEditable,
      indrets,
      individuIntroduccioModificarCamp
    } = this.props;
    const { Option } = Select;

    if (!esEditable) {
      return dadesEditades ? dadesEditades[nomCampNomIndret] : "";
    }

    if (!indrets || !Array.isArray(indrets)) {
      return "";
    }

    const idIndretSeleccionat =
      dadesEditades && dadesEditades[nomCampIdIndret] !== null
        ? dadesEditades[nomCampIdIndret]
        : "";

    const idObservadorSeleccionat =
      dadesEditades && dadesEditades[nomCampIdObservador] !== null
        ? dadesEditades[nomCampIdObservador]
        : "";

    const llistaIndretMostrar = idObservadorSeleccionat
      ? indrets.filter(indret => {
          return (
            indret.idObservador === parseInt(idObservadorSeleccionat) &&
            !indret.dataBaixa
          );
        })
      : [];

    const llistaIndretSeleccionat = indrets.filter(indret => {
      return indret.id === parseInt(idIndretSeleccionat);
    });

    const nomIndretSeleccionat =
      llistaIndretSeleccionat && llistaIndretSeleccionat.length > 0
        ? `${llistaIndretSeleccionat[0].nom
            ? llistaIndretSeleccionat[0].nom
            : ""}`
        : "";

    const valor =
      idIndretSeleccionat && nomIndretSeleccionat
        ? `${nomIndretSeleccionat}${separador}${idIndretSeleccionat}`
        : idObservadorSeleccionat ? "Selecciona un indret..." : "";

    const idCamp = `id-${nomCampIdIndret}`;
    const nomCamp = `id-${nomCampIndret}`;

    return (
      <Select
        showSearch
        placeholder="Selecciona un indret..."
        style={{ width: "100%", maxHeight: 100 }}
        id={idCamp}
        aria-labelledby={nomCamp}
        disabled={!idObservadorSeleccionat ? true : false}
        onChange={valorSeleccionat => {
          const idIndret = valorSeleccionat.substr(
            valorSeleccionat.indexOf(separador) + 2
          );
          const nomIndret = valorSeleccionat.substr(
            0,
            valorSeleccionat.indexOf(separador)
          );
          individuIntroduccioModificarCamp(nomCampIdIndret, parseInt(idIndret));
          individuIntroduccioModificarCamp(nomCampIndret, nomIndret);
        }}
        value={valor ? valor : ""}
      >
        {llistaIndretMostrar.map(indret => {
          const nomindret = `${indret.nom}`;
          return (
            <Option
              key={indret.id}
              value={`${nomindret}${separador}${indret.id}`}
            >
              {nomindret}
            </Option>
          );
        })}
      </Select>
    );
  }

  renderitzarCampVarietat() {
    const {
      dadesEditades,
      esEditable,
      varietats,
      individuIntroduccioModificarCamp
    } = this.props;
    const { Option } = Select;

    if (!esEditable) {
      return dadesEditades ? dadesEditades[nomCampVarietat] : "";
    }

    if (!varietats || !Array.isArray(varietats)) {
      return "";
    }

    const idVarietatSeleccionada =
      dadesEditades && dadesEditades[nomCampIdVarietat] !== null
        ? dadesEditades[nomCampIdVarietat]
        : "";

    const idEspecieSeleccionada =
      dadesEditades && dadesEditades[nomCampIdEspecie] !== null
        ? dadesEditades[nomCampIdEspecie]
        : "";

    const llistaVarietatsMostrar = idEspecieSeleccionada
      ? varietats.filter(varietat => {
          return varietat.idEspecie === parseInt(idEspecieSeleccionada);
        })
      : [];

    const llistaVarietatSeleccionada = varietats.filter(varietat => {
      return varietat.id === parseInt(idVarietatSeleccionada);
    });

    const nomVarietatSeleccionada =
      llistaVarietatSeleccionada && llistaVarietatSeleccionada.length > 0
        ? `${llistaVarietatSeleccionada[0].nom
            ? llistaVarietatSeleccionada[0].nom
            : ""}`
        : "";

    const valor =
      idVarietatSeleccionada && nomVarietatSeleccionada
        ? `${nomVarietatSeleccionada}${separador}${idVarietatSeleccionada}`
        : idEspecieSeleccionada ? "Selecciona un varietat..." : "";
    const idCamp = `id-${nomCampIdVarietat}`;
    const nomCamp = `id-${nomCampVarietat}`;

    return (
      <Select
        showSearch
        placeholder="Selecciona un varietat..."
        style={{ width: "100%", maxHeight: 100 }}
        aria-labelledby={nomCamp}
        id={idCamp}
        disabled={!idEspecieSeleccionada ? true : false}
        onChange={valorSeleccionat => {
          const idVarietat = valorSeleccionat.substr(
            valorSeleccionat.indexOf(separador) + 2
          );
          const nomVarietat = valorSeleccionat.substr(
            0,
            valorSeleccionat.indexOf(separador)
          );

          individuIntroduccioModificarCamp(
            nomCampIdVarietat,
            parseInt(idVarietat)
          );
          individuIntroduccioModificarCamp(
            nomCampVarietat,
            String(nomVarietat)
          );
        }}
        value={valor ? valor : ""}
      >
        {llistaVarietatsMostrar.map(varietat => {
          const nomVarietat = `${varietat.nom}`;
          return (
            <Option
              key={varietat.id}
              value={`${nomVarietat}${separador}${varietat.id}`}
            >
              {nomVarietat}
            </Option>
          );
        })}
      </Select>
    );
  }

  renderitzarCampSubEspecie() {
    const {
      dadesEditades,
      esEditable,
      subEspecies,
      individuIntroduccioModificarCamp
    } = this.props;
    const { Option } = Select;

    if (!esEditable) {
      return dadesEditades ? dadesEditades[nomCampSubEspecie] : "";
    }

    if (!subEspecies || !Array.isArray(subEspecies)) {
      return "";
    }

    const idSubEspecieSeleccionada =
      dadesEditades && dadesEditades[nomCampIdSubEspecie] !== null
        ? dadesEditades[nomCampIdSubEspecie]
        : "";

    const idEspecieSeleccionada =
      dadesEditades && dadesEditades[nomCampIdEspecie] !== null
        ? dadesEditades[nomCampIdEspecie]
        : "";

    const llistaSubEspeciesMostrar = idEspecieSeleccionada
      ? subEspecies.filter(subEspecie => {
          return subEspecie.idEspecie === parseInt(idEspecieSeleccionada);
        })
      : [];

    const llistaSubEspeciesSeleccionada = subEspecies.filter(subEspecie => {
      return subEspecie.id === parseInt(idSubEspecieSeleccionada);
    });

    const nomSubEspecieSeleccionada =
      llistaSubEspeciesSeleccionada && llistaSubEspeciesSeleccionada.length > 0
        ? `${llistaSubEspeciesSeleccionada[0].nom
            ? llistaSubEspeciesSeleccionada[0].nom
            : ""}`
        : "";

    const valor =
      idSubEspecieSeleccionada && nomSubEspecieSeleccionada
        ? `${nomSubEspecieSeleccionada}${separador}${idSubEspecieSeleccionada}`
        : idEspecieSeleccionada ? "Selecciona un subEspècie..." : "";
    const idCamp = `id-${nomCampIdSubEspecie}`;
    const nomCamp = `id-${nomCampSubEspecie}`;

    return (
      <Select
        showSearch
        placeholder="Selecciona un subEspècie..."
        style={{ width: "100%", maxHeight: 100 }}
        id={idCamp}
        aria-labelledby={nomCamp}
        disabled={!idEspecieSeleccionada ? true : false}
        onChange={valorSeleccionat => {
          const idSubEspecie = valorSeleccionat.substr(
            valorSeleccionat.indexOf(separador) + 2
          );
          const nomSubEspecie = valorSeleccionat.substr(
            0,
            valorSeleccionat.indexOf(separador)
          );

          individuIntroduccioModificarCamp(
            nomCampIdSubEspecie,
            parseInt(idSubEspecie)
          );
          individuIntroduccioModificarCamp(
            nomCampSubEspecie,
            String(nomSubEspecie)
          );
        }}
        value={valor ? valor : ""}
      >
        {llistaSubEspeciesMostrar.map(subEspecie => {
          const nomSubEspecie = `${subEspecie.nom}`;
          return (
            <Option
              key={subEspecie.id}
              value={`${nomSubEspecie}${separador}${subEspecie.id}`}
            >
              {nomSubEspecie}
            </Option>
          );
        })}
      </Select>
    );
  }

  renderitzarCampEspecies(haFetObservacions) {
    const {
      dadesEditades,
      esEditable,
      classes,
      generes,
      collectius,
      regnes,
      especies,
      individuIntroduccioModificarCamp
    } = this.props;

    const { Option } = Select;
    const idEspecieSeleccionada =
      dadesEditades && dadesEditades[nomCampIdEspecie] !== null
        ? dadesEditades[nomCampIdEspecie]
        : "";

    if (!esEditable || haFetObservacions) {
      return dadesEditades ? dadesEditades[nomCampEspecie] : "";
    }

    if (
      !classes ||
      !Array.isArray(classes) ||
      !especies ||
      !Array.isArray(especies)
    ) {
      return "";
    }

    const llistaEspecieSeleccionada = especies.filter(especie => {
      return especie.id === parseInt(idEspecieSeleccionada);
    });

    const nomEspecieSeleccionada =
      llistaEspecieSeleccionada && llistaEspecieSeleccionada.length > 0
        ? `${llistaEspecieSeleccionada[0].nom
            ? llistaEspecieSeleccionada[0].nom
            : ""}`
        : "";

    const valor =
      idEspecieSeleccionada && nomEspecieSeleccionada
        ? `${nomEspecieSeleccionada}${separador}${idEspecieSeleccionada}`
        : "";
    const idCamp = `id-${nomCampIdEspecie}`;
    const nomCamp = `id-${nomCampEspecie}`;

    let especiesOrdenadas = [...especies];
    especiesOrdenadas.sort((a, b) => {
      if (a.nom < b.nom) {
        return -1;
      }
      if (a.nom > b.nom) {
        return 1;
      }
      return 0;
    });

    return (
      <Select
        showSearch
        placeholder="Selecciona una espècie..."
        style={{ width: "100%", maxHeight: 100 }}
        id={idCamp}
        aria-labelledby={nomCamp}
        onChange={valorSeleccionat => {
          const idEspecie = valorSeleccionat.substr(
            valorSeleccionat.indexOf(separador) + 2
          );
          const nomEspecie = valorSeleccionat.substr(
            0,
            valorSeleccionat.indexOf(separador)
          );

          const especieSeleccionada = especies.filter(especie => {
            return especie.id === parseInt(idEspecie);
          });

          const nomCientificEspecieSeleccionada =
            Array.isArray(especieSeleccionada) && especieSeleccionada.length > 0
              ? especieSeleccionada[0].nomCientific
              : "";

          const idGenereEspecieSeleccionada =
            Array.isArray(especieSeleccionada) && especieSeleccionada.length > 0
              ? especieSeleccionada[0].idGenere
              : "";
          const genere = generes.filter(genere => {
            return genere.id === parseInt(idGenereEspecieSeleccionada);
          });
          const nomGenereEspecieSeleccionada =
            Array.isArray(genere) && genere.length > 0 ? genere[0].nom : "";
          const idCollectiuEspecieSeleccionada =
            Array.isArray(genere) && genere.length > 0
              ? genere[0].idCollectiu
              : "";
          const collectiu = collectius.filter(collectiu => {
            return collectiu.id === parseInt(idCollectiuEspecieSeleccionada);
          });
          const nomCollectiuEspecieSeleccionada =
            Array.isArray(collectiu) && collectiu.length > 0
              ? collectiu[0].nom
              : "";
          const idClasseEspecieSeleccionada =
            Array.isArray(collectiu) && collectiu.length > 0
              ? collectiu[0].idClasse
              : "";
          const classe = classes.filter(classe => {
            return classe.id === parseInt(idClasseEspecieSeleccionada);
          });
          const nomClasseEspecieSeleccionada =
            Array.isArray(classe) && classe.length > 0 ? classe[0].nom : "";
          const idRegneEspecieSeleccionada =
            Array.isArray(classe) && classe.length > 0 ? classe[0].idRegne : "";
          const regne = regnes.filter(regne => {
            return regne.id === parseInt(idRegneEspecieSeleccionada);
          });
          const nomRegneEspecieSeleccionada =
            Array.isArray(regne) && regne.length > 0 ? regne[0].nom : "";
          const esIndividuVegetal =
            idClasseEspecieSeleccionada === ID_CLASSE_VEGETAL ? true : false;

          individuIntroduccioModificarCamp(nomCampIdEspecie, String(idEspecie));
          individuIntroduccioModificarCamp(nomCampEspecie, String(nomEspecie));
          individuIntroduccioModificarCamp(
            nomCampNomCientific,
            String(nomCientificEspecieSeleccionada)
          );
          individuIntroduccioModificarCamp(
            nomCampGenere,
            String(nomGenereEspecieSeleccionada)
          );
          individuIntroduccioModificarCamp(
            nomCampCollectiu,
            String(nomCollectiuEspecieSeleccionada)
          );
          individuIntroduccioModificarCamp(
            nomCampClasse,
            String(nomClasseEspecieSeleccionada)
          );
          individuIntroduccioModificarCamp(
            idCampClasse,
            String(idClasseEspecieSeleccionada)
          );
          individuIntroduccioModificarCamp(
            nomCampRegne,
            String(nomRegneEspecieSeleccionada)
          );
          individuIntroduccioModificarCamp(
            nomCampNomCientific,
            String(nomCientificEspecieSeleccionada)
          );
          individuIntroduccioModificarCamp(nomCampfenofases, null);
          individuIntroduccioModificarCamp(nomCampIndret, null);
          individuIntroduccioModificarCamp(nomCampVarietat, null);
          individuIntroduccioModificarCamp(nomCampIdVarietat, null);
          individuIntroduccioModificarCamp(nomCampSubEspecie, null);
          individuIntroduccioModificarCamp(nomCampIdSubEspecie, null);
          individuIntroduccioModificarCamp(
            nomCampOrientacio,
            esIndividuVegetal
              ? ORIENTACIO_NOM_VALOR_DEFECTE
              : !ORIENTACIO_NOM_VALOR_DEFECTE
          );
          individuIntroduccioModificarCamp(
            nomCampOrigen,
            esIndividuVegetal
              ? ORIGEN_NOM_VALOR_DEFECTE
              : !ORIGEN_NOM_VALOR_DEFECTE
          );
          individuIntroduccioModificarCamp(
            nomCampIrrigacio,
            esIndividuVegetal
              ? IRRIGACIO_NOM_VALOR_DEFECTE
              : !IRRIGACIO_NOM_VALOR_DEFECTE
          );
          individuIntroduccioModificarCamp(
            nomCampTractament,
            esIndividuVegetal
              ? TRACTAMENT_NOM_VALOR_DEFECTE
              : !TRACTAMENT_NOM_VALOR_DEFECTE
          );
        }}
        value={valor ? valor : "Selecciona una espècie..."}
      >
        {especiesOrdenadas.map(especie => {
          const nomEspecie = `${especie.nom ? especie.nom : ""}`;
          return (
            <Option
              key={especie.id}
              value={`${nomEspecie}${separador}${especie.id}`}
            >
              {nomEspecie}
            </Option>
          );
        })}
      </Select>
    );
  }

  renderitzarCampSwitch(camp, valorDefecte, valorChecked, valorUnChecked) {
    const {
      dadesEditades,
      esEditable,
      individuIntroduccioModificarCamp
    } = this.props;

    if (!esEditable) {
      if (valorChecked === "Si" && valorUnChecked === "No") {
        return <div>{this.renderitzarComponentBoolean(camp, esEditable)}</div>;
      } else {
        return <div>{this.renderitzarComponentText(camp, esEditable)}</div>;
      }
    }

    const valorSeleccionat =
      dadesEditades[camp] !== null ? dadesEditades[camp] : valorDefecte;

    const idCamp = `id-${camp}`;

    return (
      <Switch
        id={idCamp}
        aria-labelledby={"id-" + idCamp}
        checkedChildren={valorChecked ? valorChecked : ""}
        unCheckedChildren={valorUnChecked ? valorUnChecked : ""}
        defaultChecked={valorSeleccionat}
        onChange={valorSeleccionat =>
          individuIntroduccioModificarCamp(camp, valorSeleccionat)}
      />
    );
  }

  renderCampsVegetals(llistaErrors, esEditable) {
    const errorCampOrientacio = llistaErrors[nomCampOrientacio];
    const errorCampOrigen = llistaErrors[nomCampOrigen];
    const errorCampIrrigacio = llistaErrors[nomCampIrrigacio];
    const errorCampTractament = llistaErrors[nomCampTractament];
    const errorCampGenotip = llistaErrors[nomCampGenotip];
    return (
      <div className={styles.individuCampsVegetals}>
        <div className={styles.individuOrientacio}>
          <span id={"id-id-" + nomCampOrientacio} className={styles.label}>
            Orientació:
          </span>
          <div>
            {this.renderitzarCampSwitch(
              nomCampOrientacio,
              ORIENTACIO_NOM_VALOR_DEFECTE,
              ORIENTACIO_NOM_VALOR_SOLANA,
              ORIENTACIO_NOM_VALOR_OBAGA
            )}
          </div>
          {renderitzarError(errorCampOrientacio)}
        </div>

        <div className={styles.individuOrigen}>
          <span id={"id-id-" + nomCampOrigen} className={styles.label}>
            Conreada:
          </span>
          <div>
            {this.renderitzarCampSwitch(
              nomCampOrigen,
              ORIGEN_NOM_VALOR_DEFECTE,
              "Si",
              "No"
            )}
          </div>
          {renderitzarError(errorCampOrigen)}
        </div>

        <div className={styles.individuIrrigacio}>
          <span id={"id-id-" + nomCampIrrigacio} className={styles.label}>
            Reg:
          </span>
          <div>
            {this.renderitzarCampSwitch(
              nomCampIrrigacio,
              IRRIGACIO_NOM_VALOR_DEFECTE,
              "Si",
              "No"
            )}
          </div>
          {renderitzarError(errorCampIrrigacio)}
        </div>

        <div className={styles.individuTractament}>
          <span id={"id-id-" + nomCampTractament} className={styles.label}>
            Fertilització:
          </span>
          <div>
            {this.renderitzarCampSwitch(
              nomCampTractament,
              TRACTAMENT_NOM_VALOR_DEFECTE,
              "Si",
              "No"
            )}
          </div>
          {renderitzarError(errorCampTractament)}
        </div>

        <div className={styles.individuGenotip}>
          <span id={"id-id-" + nomCampGenotip} className={styles.label}>
            Genotip:
          </span>
          <div>{this.renderitzarComponentText(nomCampGenotip, esEditable)}</div>
          {renderitzarError(errorCampGenotip)}
        </div>
      </div>
    );
  }

  renderitzarSeccioDadesIndividu() {
    const {
      esEditable,
      dadesEditades,
      dadesOriginals,
      errors,
      mostrarErrors,
      numObservacions
    } = this.props;

    const esNouIndividu =
      dadesOriginals[nomCampIdObservador] === null ? true : false;

    const haFetObservacions = esNouIndividu
      ? false
      : numObservacions > 0 ? true : false;

    const esIndividuVegetal =
      parseInt(dadesEditades.idClasse) === ID_CLASSE_VEGETAL ? true : false;

    if (!esEditable && dadesOriginals[nomCampIdObservador] === null) {
      return null;
    }

    const mostrarDataBaixa =
      dadesOriginals && dadesOriginals.dataBaixa ? true : false;

    let llistaErrors = [];
    if (mostrarErrors) {
      llistaErrors = errors;
    }

    const errorCampNomObservador = llistaErrors[nomCampObservador];
    const errorCampNomIndret = llistaErrors[nomCampNomIndret];
    const errorCampDescripcio = llistaErrors[nomCampDescripcio];
    const errorCampNomCientific = llistaErrors[nomCampNomCientific];
    const errorCampDataAlta = llistaErrors[nomCampDataAlta];
    const errorCampDataBaixa = llistaErrors[nomCampDataBaixa];
    const errorCampLatitud = llistaErrors[nomCampLatitud];
    const errorCampLongitud = llistaErrors[nomCampLongitud];
    const errorCampAltitud = llistaErrors[nomCampAltitud];
    const errorCampRegne = llistaErrors[nomCampRegne];
    const errorCampClasse = llistaErrors[nomCampClasse];
    const errorCampCollectiu = llistaErrors[nomCampCollectiu];
    const errorCampGenere = llistaErrors[nomCampGenere];
    const errorCampEspecie = llistaErrors[nomCampEspecie];
    const errorCampSubEspecie = llistaErrors[nomCampSubEspecie];
    const errorCampVarietat = llistaErrors[nomCampVarietat];
    const errorCampFenofases = llistaErrors[nomCampFenofases];
    const errorCampCanvis = llistaErrors[nomCampCanvis];

    return (
      <div className={styles.individuDades}>
        <div className={styles.individuNomObservador}>
          <span id={"id-" + nomCampObservador} className={styles.label}>
            Observador:
          </span>
          <div>{this.renderitzarCampObservador()}</div>
          {renderitzarError(errorCampNomObservador)}
        </div>

        <div className={styles.individuIndret}>
          <span id={"id-" + nomCampIndret} className={styles.label}>
            Indret:
          </span>
          <div>{this.renderitzarCampIndret()}</div>
          {renderitzarError(errorCampNomIndret)}
        </div>

        <div className={styles.individuAlta}>
          <span id={"id-" + nomCampDataAlta} className={styles.label}>
            Data d'alta:
          </span>
          <div>
            {this.renderitzarComponentData(
              nomCampDataAlta,
              esEditable && esNouIndividu
            )}
          </div>
          {renderitzarError(errorCampDataAlta)}
        </div>

        {mostrarDataBaixa ? (
          <div className={styles.individuBaixa}>
            <span id={"id-" + nomCampDataBaixa} className={styles.label}>
              Data de baixa:
            </span>
            <div>{this.renderitzarComponentData(nomCampDataBaixa, false)}</div>
            {renderitzarError(errorCampDataBaixa)}
          </div>
        ) : null}

        <div className={styles.individuEspecie}>
          <span id={"id-" + nomCampIdEspecie} className={styles.label}>
            Espècie:
          </span>
          <div>
            <input
              id={nomCampIdEspecie}
              name={nomCampIdEspecie}
              type="hidden"
              aria-labelledby={"id-" + nomCampIdEspecie}
            />
            {this.renderitzarCampEspecies(haFetObservacions)}
          </div>
          {renderitzarError(errorCampEspecie)}
        </div>

        <div className={styles.individuNomCientific}>
          <span id={"id-" + nomCampNomCientific} className={styles.label}>
            Nom cientí­fic:
          </span>
          <div className={styles.nomCientific}>
            {this.renderitzarComponentCalculat(nomCampNomCientific)}
          </div>
          {renderitzarError(errorCampNomCientific)}
        </div>

        <div className={styles.individuSubEspecie}>
          <span id={"id-" + nomCampSubEspecie} className={styles.label}>
            Subespècie:
          </span>
          <div>{this.renderitzarCampSubEspecie()}</div>
          {renderitzarError(errorCampSubEspecie)}
        </div>

        <div className={styles.individuVarietat}>
          <span id={"id-" + nomCampVarietat} className={styles.label}>
            Varietat:
          </span>
          <div>{this.renderitzarCampVarietat()}</div>
          {renderitzarError(errorCampVarietat)}
        </div>

        <div className={styles.individuGenere}>
          <span id={"id-" + nomCampGenere} className={styles.label}>
            Gènere:
          </span>
          <div>{this.renderitzarComponentCalculat(nomCampGenere)}</div>
          {renderitzarError(errorCampGenere)}
        </div>

        <div className={styles.individuCollectiu}>
          <span id={"id-" + nomCampCollectiu} className={styles.label}>
            Col·lectiu:
          </span>
          <div>{this.renderitzarComponentCalculat(nomCampCollectiu)}</div>
          {renderitzarError(errorCampCollectiu)}
        </div>

        <div className={styles.individuClasse}>
          <span id={"id-" + nomCampClasse} className={styles.label}>
            Classe:
          </span>
          <div>{this.renderitzarComponentCalculat(nomCampClasse)}</div>
          {renderitzarError(errorCampClasse)}
        </div>

        <div className={styles.individuRegne}>
          <span id={"id-" + nomCampRegne} className={styles.label}>
            Regne:
          </span>
          <div>{this.renderitzarComponentCalculat(nomCampRegne)}</div>
          {renderitzarError(errorCampRegne)}
        </div>

        <div className={styles.individuDescripcio}>
          <span id={"id-" + nomCampDescripcio} className={styles.label}>
            Descripció:
          </span>
          <div>
            {this.renderitzarComponentText(nomCampDescripcio, esEditable)}
          </div>
          {renderitzarError(errorCampDescripcio)}
        </div>

        <div className={styles.individuLatitud}>
          <span id={"id-" + nomCampLatitud} className={styles.label}>
            Latitud:
          </span>
          <div>
            {this.renderitzarComponentNumber(
              nomCampLatitud,
              esEditable,
              LATITUD_MIN,
              LATITUD_MAX,
              NUM_DECIMALS_COORDENADES
            )}
          </div>
          {renderitzarError(errorCampLatitud)}
        </div>

        <div className={styles.individuLongitud}>
          <span id={"id-" + nomCampLongitud} className={styles.label}>
            Longitud:
          </span>
          <div>
            {this.renderitzarComponentNumber(
              nomCampLongitud,
              esEditable,
              LONGITUD_MIN,
              LONGITUD_MAX,
              NUM_DECIMALS_COORDENADES
            )}
          </div>
          {renderitzarError(errorCampLongitud)}
        </div>

        <div className={styles.individuAltitud}>
          <span id={"id-" + nomCampAltitud} className={styles.label}>
            Altura (m):
          </span>
          <div>
            {this.renderitzarComponentNumber(
              nomCampAltitud,
              esEditable,
              VALOR_MIN_ALÇADA_INDIVIDU,
              VALOR_MAX_ALÇADA_INDIVIDU,
              0
            )}
          </div>
          {renderitzarError(errorCampAltitud)}
        </div>

        {esIndividuVegetal ? (
          this.renderCampsVegetals(llistaErrors, esEditable)
        ) : null}

        <div className={styles.individuFenofases}>
          <span id={"id-id-" + nomCampFenofases} className={styles.label}>
            Fenofases:
          </span>
          <div>{this.renderitzarCampFenofases()}</div>
          {renderitzarError(errorCampFenofases)}
        </div>

        {!esNouIndividu ? (
          <div className={styles.individuCanvis}>
            <span id={"id-" + nomCampCanvis} className={styles.label}>
              Canvis:
            </span>
            <div>
              {this.renderitzarComponentTextArea(nomCampCanvis, esEditable)}
            </div>
            {renderitzarError(errorCampCanvis)}
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    return (
      <div className={styles.individusFormulari + " " + styles.camp}>
        {this.renderitzarSeccioDadesIndividu()}
      </div>
    );
  }
}

IndividuFormulari.propTypes = {
  esEditable: PropTypes.bool,
  history: PropTypes.object,
  individuIntroduccioModificarCamp: PropTypes.func,
  observadors: PropTypes.array,
  dadesEditades: PropTypes.object,
  dadesOriginals: PropTypes.object,
  errors: PropTypes.object,
  setTitolApartat: PropTypes.func.isRequired,
  inicialitzarIndividu: PropTypes.func.isRequired,
  obtenirObservadorsLlistat: PropTypes.func,
  obtenirDadesCreacioIndividu: PropTypes.func,
  obtenirDadesVisualitzacio: PropTypes.func.isRequired,
  especies: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      nom: PropTypes.string.isRequired
    })
  ),
  classes: PropTypes.object,
  fenofases: PropTypes.array,
  numObservacions: PropTypes.number
};

const mapStateToProps = state => {
  return {
    dadesEditades: getDadesEditadesIndividu(state),
    dadesOriginals: getDadesOriginalsIndividu(state),
    errors: obtenirErrorsDadesIndividu(state.individus.formulari.editades),
    mostrarErrors: getMostrarErrorsIndividu(state),
    observadors: getObservadorsUsuari(state),
    collectius: obtenirCollectius(state),
    generes: obtenirGeneres(state),
    indrets: obtenirIndrets(state),
    regnes: obtenirRegnes(state),
    especies: getTotesEspecies(state),
    classes: getTotesClasses(state),
    subEspecies: obtenirSubEspecies(state),
    varietats: obtenirVarietats(state),
    fenofases: getTotesFenofases(state),
    numObservacions: getNumObservacions(state)
  };
};

const mapDispatchToProps = {
  setTitolApartat,
  inicialitzarIndividu,
  individuIntroduccioModificarCamp,
  obtenirObservadorsLlistat,
  obtenirDadesCreacioIndividu,
  obtenirDadesVisualitzacio
};

export default ErrorBoundaryWrapper(
  connect(mapStateToProps, mapDispatchToProps)(IndividuFormulari)
);
